import { render, staticRenderFns } from "./ResultsShow.vue?vue&type=template&id=af405e88"
import script from "./ResultsShow.vue?vue&type=script&lang=js"
export * from "./ResultsShow.vue?vue&type=script&lang=js"
import style0 from "./ResultsShow.vue?vue&type=style&index=0&id=af405e88&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports